/**
 * Footer compartido entre páginas marketing y del organizador.
 *
 * 4 columnas: marca · Soluciones · Producto · Tu cuenta.
 * Reglón inferior con tagline + email contacto + link legal.
 *
 * NO usar en: PublicPage, SharePage, ParticipantPage, CasetaBonoPage,
 * EmbedPage (focus mode). En CasetaAdminPage tampoco (es panel
 * embebido en feria, sin distracciones).
 */
import { Link } from 'react-router-dom';


export default function Footer() {
  return (
    <footer className="bg-paper border-t border-line mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <Mark />
              <span className="font-display font-bold text-[17px] text-ink tracking-[-0.01em]">
                Pagafácil
              </span>
            </div>
            <p className="text-[12px] text-ink-500 leading-relaxed">
              Cobros colectivos sin liarse · Hub para entidades ·
              sub-marcas verticales.
            </p>
          </div>
          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-500 mb-3">
              · Soluciones
            </div>
            <ul className="space-y-1.5 text-[13px]">
              <li><Link to="/coordina" className="text-ink-700 hover:text-ink">Coordina</Link></li>
              <li><Link to="/propina" className="text-ink-700 hover:text-ink">Propina</Link></li>
              <li><Link to="/oficina" className="text-ink-700 hover:text-ink">Oficina Fácil</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-500 mb-3">
              · Producto
            </div>
            <ul className="space-y-1.5 text-[13px]">
              <li><Link to="/empezar" className="text-ink-700 hover:text-ink">Empezar guiado</Link></li>
              <li><Link to="/nuevo" className="text-ink-700 hover:text-ink">Crear cobro</Link></li>
              <li><Link to="/precio" className="text-ink-700 hover:text-ink">Precio</Link></li>
              <li><Link to="/sorteos-publicos" className="text-ink-700 hover:text-ink">Sorteos abiertos</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-500 mb-3">
              · Tu cuenta
            </div>
            <ul className="space-y-1.5 text-[13px]">
              <li><Link to="/mis-cobros" className="text-ink-700 hover:text-ink">Mis cobros</Link></li>
              <li><Link to="/entidades" className="text-ink-700 hover:text-ink">Mi entidad</Link></li>
              <li><Link to="/partners" className="text-ink-700 hover:text-ink">Partners CRM</Link></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t border-line flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-ink-500">
          <span className="font-mono uppercase tracking-[0.12em]">
            Sin app · sin login · pago seguro
          </span>
          <span className="font-mono uppercase tracking-[0.12em]">
            Pagafácil S.L. ·{' '}
            <a href="mailto:hola@pagafacil.eu" className="text-ink-700 hover:text-ink">
              hola@pagafacil.eu
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}


function Mark() {
  return (
    <div
      className="rounded-full w-[22px] h-[22px] shrink-0"
      style={{
        background: 'conic-gradient(#1C5D82 0 33%, #C2683E 0 66%, #5E7B3E 0 100%)',
        boxShadow: 'inset 0 0 0 4px #FBF7F0',
      }}
      aria-hidden
    />
  );
}
